import "./YellowIntroduction.css"
import { motion, useInView, useSpring, useTransform } from "framer-motion";
import { useEffect, useState, useRef } from "react";


const Counter = ({ value }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true });
    const spring = useSpring(0, { mass: 1, stiffness: 50, damping: 30 });
    const display = useTransform(spring, (current) => Math.round(current));

    useEffect(() => {
        if (inView) spring.set(value);
    }, [inView, value, spring]);

    return <motion.span ref={ref}>{display}</motion.span>;
};

const YellowIntroduction = ({ref}) => {
    const [isMobile, setMobile] = useState(false);
    
    
    useEffect(() => {
        const handleResize = () => setMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.3 } // Elemanlar sırayla gelecek
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1 }
    };

    return (
        <motion.div
            variants={containerVariants}
            initial="hidden"
            ref={ref}
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="yellow-introduction-container"
        >
            <div className="yellow-introduction-container-overlay">
                {[
                    { num: 404, label: "Konut" },
                    { num: 114, label: "Dükkan" },
                    { num: 12, label: "Ofis" }
                ].map((item, index) => (
                    <motion.div key={index} variants={itemVariants} className="stat-item">
                        <div className="stat-number">
                            <Counter value={item.num} />
                        </div>
                        <div className="stat-label">{item.label}</div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
}

export default YellowIntroduction;